import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { tenureOptions } from "helpers/utils"
import LoaderComponent from "components/loader"
import {
  useLazyGetReferalQuery,
  useUpdateReferalMutation,
} from "store/api/wealthpartnerapi/referrals/referrals.api"

const defaultValues = {
  entity_type: "INDIVIDUAL",
  name: "",
  preference: [],
  email: "",
  pan_no: "",
}

const InvestorManagementInvite = () => {
  const { id } = useParams()

  const history = useNavigate()

  document.title = "Update Referral | Prachay"

  const [getResult, { isFetching }] = useLazyGetReferalQuery()
  const [reInviteInvestor, { isLoading }] = useUpdateReferalMutation()
  const [userData, setUserData] = useState(defaultValues)

  useEffect(() => {
    const getUser = async () => {
      const { data } = await getResult({ id }).unwrap()
      setUserData({
        entity_type: data.entity_type,
        name: data.name,
        email: data.email,
        pan_no: data.pan_no,
        preference: data.preference,
      })

      if (data.status === "KYC_PENDING") {
        history(`/investor-management/view/${id}`)
      }
    }
    getUser()
  }, [id])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...userData },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await onFormSubmit(values)
    },
  })

  const onFormSubmit = async (values) => {
    try {
      const { message, success } = await reInviteInvestor({
        ...values,
        id,
      }).unwrap()

      if (success) {
        history("/investor-management")
        toast.success(message, { id: "inviteToastMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "inviteToastMessage" })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Update Investor"} />
          {isFetching ? (
            <LoaderComponent />
          ) : (
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row className="mb-2">
                        <Col xl={6} className="mb-2">
                          <Label className="form-label">Entity Type</Label>
                          <select
                            name="entity_type"
                            className="form-select pageSize mb-2"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.entity_type || ""}
                          >
                            {[
                              { label: "Individual", value: "INDIVIDUAL" },
                              { label: "Business", value: "COMPANY" },
                            ].map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          {validation.touched.entity_type &&
                          validation.errors.entity_type ? (
                            <FormFeedback type="invalid">
                              {validation.errors.entity_type}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col xl={6} className="mb-2">
                          <Label className="form-label">
                            {validation.values.entity_type === "INDIVIDUAL"
                              ? "Name"
                              : "Company Name"}
                          </Label>
                          <Input
                            name="name"
                            className="form-control"
                            placeholder={
                              validation.values.entity_type === "INDIVIDUAL"
                                ? "Enter Name"
                                : "Enter Company Name"
                            }
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col xl={6} className="mb-2">
                          <Label className="form-label">Email Address</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter Email Address"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}{" "}
                        </Col>
                        {/* <Col xl={6} className="mb-2">
                          <Label className="form-label">Preferences</Label>
                          <div className="d-flex gap-5 mt-2">
                            {tenureOptions.map((item, index) => (
                              <div
                                className="form-check form-check-primary mb-2"
                                key={`preference_${index}`}
                              >
                                <input
                                  type="checkbox"
                                  name="preference"
                                  id={item.key}
                                  value={item.key}
                                  className="form-check-input"
                                  onChange={(e) => {
                                    const { checked, value } = e.target
                                    const newPreferences = checked
                                      ? [...validation.values.preference, value]
                                      : validation.values.preference.filter(
                                          (v) => v !== value
                                        )
                                    validation.setFieldValue(
                                      "preference",
                                      newPreferences
                                    )
                                  }}
                                  onBlur={validation.handleBlur}
                                  checked={validation.values.preference.includes(
                                    item.key
                                  )}
                                />

                                <label
                                  className="form-check-label"
                                  htmlFor={item.key}
                                >
                                  {item.label}
                                </label>
                              </div>
                            ))}
                          </div>
                          {validation.touched.preference &&
                            validation.errors.preference && (
                              <div className="invalid-feedback d-block">
                                {validation.errors.preference}
                              </div>
                            )}
                        </Col> */}
                        <Col xl={6} className="mb-2">
                          <Label className="form-label">PAN</Label>
                          <Input
                            name="pan_no"
                            className="form-control"
                            placeholder="PAN"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.pan_no || ""}
                            invalid={
                              validation.touched.pan_no &&
                              validation.errors.pan_no
                                ? true
                                : false
                            }
                          />
                          {validation.touched.pan_no &&
                          validation.errors.pan_no ? (
                            <FormFeedback type="invalid">
                              {validation.errors.pan_no}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <div className="mt-3 py-1 button-wrapper">
                        <Link to={"/investor-management"}>
                          <button type="button" className="cancel">
                            Cancel
                          </button>
                        </Link>
                        <Button
                          type="submit"
                          color="primary"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinners /> : "Send invite"}
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvestorManagementInvite
